<ng-content></ng-content>
<ok-stamp></ok-stamp>
